export const includes = (arr, item) => arr.indexOf(item) !== -1

export const areEqual = (arr1, arr2) =>
  JSON.stringify(arr1) === JSON.stringify(arr2)

export const areEqualSets = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false
  return arr1.every(item => includes(arr2, item))
}
